import { render } from "./AdsWidget.vue?vue&type=template&id=854d1446&ts=true"
import script from "./AdsWidget.vue?vue&type=script&lang=ts"
export * from "./AdsWidget.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__